/** Cliente HTTP do servidor local. */

import type { ResultadoConsulta, TribunalPublico } from "@consulta/core";

export interface OpcoesConsulta {
  readonly tribunais?: readonly string[];
  readonly incluirSuperiores?: boolean;
}

export interface Limites {
  readonly maxLote: number;
  readonly maxConcorrencia: number;
}

async function postar<T>(caminho: string, corpo: unknown): Promise<T> {
  const resposta = await fetch(caminho, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(corpo),
  });
  if (!resposta.ok) {
    const detalhe = await resposta.json().catch(() => null);
    const mensagem =
      detalhe && typeof detalhe === "object" && "erro" in detalhe
        ? String((detalhe as { erro: unknown }).erro)
        : `O servidor respondeu ${resposta.status}.`;
    throw new Error(mensagem);
  }
  return (await resposta.json()) as T;
}

export async function consultar(numero: string, opcoes: OpcoesConsulta = {}): Promise<ResultadoConsulta> {
  const { resultado } = await postar<{ resultado: ResultadoConsulta }>("/api/consulta", { numero, ...opcoes });
  return resultado;
}

export async function consultarLote(
  numeros: readonly string[],
  opcoes: OpcoesConsulta = {},
): Promise<ResultadoConsulta[]> {
  const { resultados } = await postar<{ resultados: ResultadoConsulta[] }>("/api/consulta/lote", {
    numeros,
    ...opcoes,
  });
  return resultados;
}

export async function buscarTribunais(): Promise<TribunalPublico[]> {
  const r = await fetch("/api/tribunais");
  if (!r.ok) throw new Error("Não foi possível carregar a lista de tribunais.");
  return ((await r.json()) as { tribunais: TribunalPublico[] }).tribunais;
}

export async function buscarLimites(): Promise<Limites> {
  const r = await fetch("/api/limites");
  if (!r.ok) return { maxLote: 50, maxConcorrencia: 4 };
  return (await r.json()) as Limites;
}
